import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { QueriesResults, QueryFunctionContext, UseQueryOptions } from "@tanstack/react-query";
import { useQueries } from "@tanstack/react-query";
import { homePageQueryKeys } from "../services/queries/queryKeyFactory";
import type { AssetsCountDto } from "../types/dto";
import type { SavedSearchesItemDto } from "../types/savedSearchesDto";

const createQueryOptions = ({ searchId }: SavedSearchesItemDto): UseQueryOptions => ({
    queryKey: homePageQueryKeys.savedSearchesCounts(searchId),
    retry: false,
    throwOnError: true,
    queryFn({ signal }: QueryFunctionContext): Promise<AssetsCountDto> {
        return salesApiService.home.fetchSavedSearchesCounts(
            {
                searchId,
            },
            {
                cancellation: signal,
            },
        );
    },
});

const useSavedSearchesCountsQueries = (items: readonly SavedSearchesItemDto[]): QueriesResults<AssetsCountDto[]> => {
    return useQueries({
        queries: items.map(createQueryOptions)
    });
};

export default useSavedSearchesCountsQueries;
